import request from '@/api/request.js'


export const getCarouselImage = ()=>request({url:'/about/slideshow',method:'get'})

export const getServiceList = (pageNum,pageSize)=>request({url:`/service/list?pageNum=${pageNum}&pageSize=${pageSize}`,method:'get'})

export const getAbout = ()=>request({url:'/about/indexAbout',method:'get'})

export const getTalentRecruitment = ()=>request({url:'/about/recruitment',method:'get'})

export const reqSumbitInfo = (data)=>request({url:'/contact',method:'post',data})

export const reqPartnerInfo = ()=>request({url:'/partner/list',method:'get'})